import styled from "styled-components";
import { lighten, darken } from "polished";

const DarkStyles = styled.div`
  color: #fff;
  padding-bottom: 20px;
  /* CONTAINERS */
  .header-wrapper {
    h1 {
      span {
        color: ${(props) => props.theme.med_grey};
      }
      svg {
        color: ${(props) => props.theme.blue_g};
      }
    }
    .btn-toggle {
      color: #fff;
    }
  }

  .confirm-modal {
    div:first-child {
      background-color: ${(props) => props.theme.dark_navy};
      .react-select-container__value-container {
        background-color: ${(props) => props.theme.dark_input} !important;
      }
    }
  }

  .view-modal {
    div:first-child:not(
        .react-select-container__value-container,
        .react-select-container__single-value,
        .react-select-container__placeholder
      ) {
      background-color: ${(props) => props.theme.dark_navy};
    }
  }
  .content-wrapper {
    background: ${(props) => props.theme.dark_navy};
    box-shadow: none;
    h3 {
      color: #fff;
    }
  }

  .bm-menu-wrap {
    ~ div {
      background: ${(props) => props.theme.dark_navy};
    }
    .bm-menu {
      background: ${(props) => props.theme.dark_navy} !important;
      a {
        color: #b8b7ad;
        &:hover,
        &:focus {
          color: #fff;
        }
      }
    }
  }

  /* SIDEBAR + NAV */
  .navbar {
    background: ${(props) => props.theme.dark_navy} !important;
    border: 0 !important;
    .container {
      .navbar-header {
        width: 225px;
        height: 70px !important;
        .navbar-toggle {
          .icon-bar {
            background-color: ${(props) => props.theme.light_grey};
          }
          &:hover {
            background-color: ${(props) => props.theme.dark_navy};
          }
          &:focus {
            background-color: ${(props) => props.theme.primary};
          }
        }
      }
      .navbar-nav {
        .dropdown {
          > a:first-child {
            .avatar-container {
              svg {
                color: #fff !important;
              }
            }
            p {
              color: #fff !important;
            }
          }
          .dropdown-menu {
            background: ${(props) => props.theme.dark_blue} !important;
            li {
              background: ${(props) => props.theme.dark_blue} !important;
              &:hover,
              &:focus {
                background: lighten(
                  ${(props) => props.theme.dark_blue},
                  5%
                ) !important;
              }
              &.active {
                &:before {
                  border: 0 !important;
                }
              }
              a {
                border-bottom: 1px solid ${(props) => props.theme.dark_navy};
                color: #fff !important;
              }
            }
          }
        }
      }
      .navbar-default {
        border: 0px;
        -webkit-box-shadow:
          0 3px 10px rgba(100, 104, 129, 0.04),
          0 3px 10px rgba(100, 104, 129, 0.01);
        box-shadow:
          0 3px 10px rgba(100, 104, 129, 0.04),
          0 3px 10px rgba(100, 104, 129, 0.01);
      }
      li {
        &.active {
          &:before {
            content: "";
            border-left: 4px solid ${(props) => props.theme.blue_g};
          }
          transition: 0.7s;
          a {
            background: transparent !important;
            color: ${(props) => props.theme.blue_g} !important;
            svg {
              color: ${(props) => props.theme.blue_g} !important;
            }
            &:hover,
            &:focus {
              color: ${(props) => props.theme.blue_g} !important;
            }
          }
        }
        a {
          transition: 0.3s;
          font-weight: 600;
          padding-top: 20px;
          padding-bottom: 20px;
          color: ${(props) => props.theme.light_grey} !important;
          svg {
            color: ${(props) => props.theme.light_grey} !important;
          }
          &:hover,
          &:focus {
            color: ${(props) => props.theme.blue_g} !important;
          }
        }
        &:hover,
        &:focus {
          * {
            background: transparent;
            color: ${(props) => props.theme.blue_g} !important;
            transition: 0.3s;
          }
        }
      }
      .sidebar {
        background:
          linear-gradient(
            ${(props) => props.theme.dark_navy},
            rgba(0, 0, 0, 0.2)
          ),
          url("/images/Backdrop-Transparent--navy.png") no-repeat left bottom /
            200%;
        .footer-tag {
          p {
            color: #fff;
          }
        }
        .menu-header {
          a {
            color: #999 !important;
            &:hover,
            &:focus {
              color: #999 !important;
            }
          }
        }
        .accordion {
          .accordion__title {
            color: ${(props) => props.theme.light_grey};
            svg {
              color: ${(props) => props.theme.light_grey} !important;
            }
            &:hover {
              svg {
                color: ${(props) => props.theme.blue_g} !important;
              }
            }
          }
          .accordion__body {
            background: darken(4%, ${(props) => props.theme.dark_navy});
            li {
              a {
                color: #fff !important;
              }
              &.active,
              &:hover,
              &:focus {
                a {
                  color: ${(props) => props.theme.blue_g} !important;
                }
              }
            }
          }
        }
      }
    }
  }

  /* BREADCRUMBS */
  .bread-aisle {
    h1 {
      color: #fff;
    }
    .loaf {
      .active {
        color: #fff;
      }
    }

    @media screen and (max-width: 767px) {
      overflow: initial;
    }
  }

  /* FORM */
  fieldset {
    legend {
      color: #fff;
    }
  }
  .form,
  .report-filters {
    label {
      color: ${(props) => props.theme.med_grey} !important;
    }
    .form-control,
    input[type="date"],
    input[type="number"] {
      background: ${(props) => props.theme.dark_input} !important;
      color: ${(props) => props.theme.grey_g} !important;
      border: none !important;
    }
    input[type="date"] {
      padding: 0 10px;
      &::-webkit-calendar-picker-indicator {
        filter: invert(1);
      }
    }
    .form-group {
      .form-control {
        background: ${(props) => props.theme.dark_input} !important;
        color: ${(props) => props.theme.grey_g} !important;
        border: none !important;
      }
    }
    .roles {
      .checkbox {
        label {
          color: #fff !important;
        }
      }
    }
    .checkbox {
      label {
        color: ${(props) => props.theme.light_grey} !important;
      }
    }
    .form-action {
      &:hover {
        cursor: pointer;
        color: ${(props) => props.theme.blue_g};
      }
    }
  }

  .form-group {
    .form-control {
      background-color: hsl(0, 0%, 98%);
      color: ${(props) => props.theme.dark_navy} !important;
    }
    .form-control[disabled],
    .css-162g8z5 {
      color: #fff !important;
      background-color: ${(props) => lighten(0.1, props.theme.dark_navy)};
    }
    .css-10nd86i {
      color: #fff;
    }
    /* Disabled Select */
    .css-1sontr1 {
      .css-162g8z5 {
        .css-1492t68,
        .css-142w6gm {
          color: #fff !important;
        }
      }
    }
    .css-15k3avv {
      color: ${(props) => props.theme.dark_navy} !important;
    }
    .react-datepicker__header,
    .react-datepicker {
      background-color: ${(props) => props.theme.dark_navy} !important;
    }
    .react-datepicker__current-month,
    .react-datepicker__time-list-item {
      color: white !important;
    }
    .react-datepicker__time-list-item--selected,
    .react-datepicker__time-list-item:hover {
      background-color: ${(props) => props.theme.blue_g} !important;
    }
    .react-datepicker-popper {
      .react-datepicker__day-name,
      .react-datepicker__day,
      .react-datepicker__time-name {
        color: white;
      }
      .react-datepicker__current-month,
      .react-datepicker__time-list,
      .react-datepicker-time__header {
        background-color: ${(props) => props.theme.dark_navy};
        color: white;
      }
      .react-datepicker__day--selected,
      .react-datepicker__time-list-item:hover,
      .react-datepicker__day:hover,
      .react-datepicker__day--keyboard-selected {
        background-color: ${(props) => props.theme.blue_g};
      }
    }
    .react-datepicker-wrapper {
      width: 100%;
      .react-datepicker__input-container {
        width: 100%;
        input {
          background: ${(props) => props.theme.dark_input} !important;
          border: none !important;
          &[disabled] {
            background: ${(props) => lighten(0.1, props.theme.dark_navy)};
          }
        }
        .react-datepicker__close-icon {
          position: absolute;
          right: 0;
          &::after {
            background: none !important;
            color: #999;
            font-size: 16px;
            top: 40%;
            right: 0;
          }
        }
      }
    }
    .validation-message {
      color: ${(props) => lighten(0.05, props.theme.red_g)} !important;
    }
  }
  .DateRangePicker {
    width: 100%;
    .DateRangePickerInput {
      background: ${(props) => props.theme.dark_input};
      border: none;
      input,
      .DateRangePickerInput_arrow {
        color: ${(props) => props.theme.grey_g};
        background: ${(props) => props.theme.dark_input};
        svg {
          fill: ${(props) => props.theme.grey_g};
        }
      }
    }
  }

  .RichTextEditor__root___2QXK- {
    color: ${(props) => props.theme.dark_grey};
  }

  .react-toggle {
    .react-toggle-track {
      background: ${(props) => darken(0.1, props.theme.light_grey)};
      color: black;
    }
    .react-toggle-thumb {
      border: #fff;
    }
    &.react-toggle--checked {
      .react-toggle-track {
        background: ${(props) => lighten(0.1, props.theme.dark_navy)};
        svg {
          fill: #fff;
        }
      }
    }
    &:hover:not(.react-toggle--disabled) {
      .react-toggle-track {
        background: ${(props) => props.theme.dark_navy};
        .react-toggle-track-x,
        .react-toggle-track-check {
          color: #fff !important;
        }
      }
    }
    .react-toggle-track-x,
    .react-toggle-track-check {
      margin-top: 5px;
    }
  }

  /* BUTTONS */
  .btn {
    &.btn-success {
      background: ${(props) => props.theme.green_g} !important;
      color: #fff;
      &:hover,
      &:focus {
        background: ${(props) => darken(0.05, props.theme.green_g)};
      }
    }
    &.btn-blue {
      background: ${(props) => props.theme.blue_g} !important;
      color: white;
      &:disabled {
        box-shadow: 0px 2px 0px ${(props) => darken(0.1, props.theme.blue_g)} !important;
      }
    }
    &.btn-danger {
      background: ${(props) => props.theme.red_g} !important;
      color: white;
    }
    &.btn-purple {
      background: ${(props) => props.theme.purple_g} !important;
      &:hover,
      &:focus {
        background: ${(props) => darken(0.05, props.theme.purple_g)} !important;
        color: #fff;
      }
    }
    &.btn-warning {
      background: ${(props) => darken(0.15, props.theme.gold_g)} !important;
      text-transform: uppercase;
      &.btn-edit {
        margin-top: 10px !important;
        box-shadow: 0px 3px 0px ${(props) => darken(0.3, props.theme.gold_g)};
        svg {
          color: #fff;
        }
      }
      &:hover,
      &:focus {
        background: ${(props) => darken(0.2, props.theme.gold_g)};
        color: #fff;
      }
    }
    &.btn-cancel {
      background: ${(props) => props.theme.light_grey} !important;
      color: ${(props) => props.theme.dark_grey} !important;
      text-transform: uppercase;
      &:hover {
        background: ${(props) =>
          darken(0.05, props.theme.light_grey)} !important;
      }
    }
    &.btn-dark {
      background: ${(props) => props.theme.dark_blue} !important;
      border: none !important;
      color: #fff;
    }
    &.btn-default {
      &:not(.no-default) {
        background: ${(props) => props.theme.dark_blue} !important;
        color: #fff;
      }
    }
    &.btn-transparent {
      background: transparent !important;
      &:focus,
      &:hover {
        border: none;
      }
      color: #fff !important;
    }
  }

  .icon-btn {
    display: flex;
    justify-content: center;
    margin-left: auto;
    border-radius: 50%;
    color: #50accb;
    background: transparent;
    border: none;
    transition: all 0.3s ease-in-out;
  }

  .icon-btn:hover {
    transform: scale(1.1);
  }

  .icon-btn:disabled {
    cursor: not-allowed;
  }

  /* FILTER COMPONENT */
  .filter-container {
    .well {
      background: ${(props) => props.theme.dark_navy};
      border: 1px solid ${(props) => lighten(0.05, props.theme.dark_navy)};
    }
  }

  /* PANEL & NOTES */
  .panel {
    .panel-heading {
      background: ${(props) => props.theme.blue_g};
      color: #fff;
    }
    .panel-body {
      background: ${(props) => props.theme.dark_navy};
    }
    &.attachment-panel {
      .panel-body {
        /* background: ${(props) => props.theme.green_g}; */
        border: 1px solid ${(props) => lighten(0.05, props.theme.dark_navy)};
        border-left: 4px solid ${(props) => props.theme.blue_g};
      }
    }
  }

  /* MODALS */
  .modal-md {
    background: ${(props) => props.theme.dark_navy};
  }
  .modal-header {
    .close {
      color: #fff !important;
    }
  }
  .modal-body {
    .well {
      background-color: ${(props) => lighten(0.1, props.theme.dark_navy)};
      border: 0;
    }
  }
  .modal-footer {
    border: 0;
    &:empty {
      padding: 10px !important;
    }
  }

  .display-msg {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    h1 {
      color: ${(props) => props.theme.med_grey} !important;
      font-size: 25px !important;
    }
  }

  .badge {
    color: #fff !important;
  }

  /* TABLES */
  .ReactTable {
    font-family: "Nunito";
    border: 0 !important;
    a {
      text-decoration: none !important;
      color: #fff !important;
    }
    .margin-bottom {
      margin-bottom: 20px;
    }
    .pagination-bottom {
      .-pagination {
        .-center {
          .select-wrap {
            select {
              option {
                color: rgb(255, 255, 255) !important;
                background: rgb(92, 77, 77) !important;
              }
            }
          }
        }
      }
    }
    .rt-thead {
      font-size: 12px;
      border-bottom: 1px solid ${(props) => props.theme.light_grey};
      box-shadow: none !important;
      .rt-th {
        border-right: none !important;
        &:focus {
          outline: none;
        }
        & > select {
          height: 28px;
        }
      }
      .rt-resizable-header-content {
        display: flex;
        align-items: center;
        text-align: left;
        padding: 10px;
        font-weight: 600;
        color: ${(props) => props.theme.light_grey};
      }
      .rt-th.-sort-asc,
      .rt-td.-sort-asc,
      .rt-th.-sort-desc,
      .rt-td.-sort-desc {
        box-shadow: none !important;
        * {
          color: ${(props) => props.theme.light_grey};
        }
      }
      .rt-th.-sort-asc .rt-resizable-header-content::after,
      .rt-td.-sort-asc .rt-resizable-header-content::after {
        content: "▲";
        font-size: 7px;
        margin-left: 7px;
        margin-top: 1px;
      }
      .rt-th.-sort-desc .rt-resizable-header-content::after,
      .rt-td.-sort-desc .rt-resizable-header-content::after {
        content: "▼";
        font-size: 7px;
        margin-left: 7px;
        margin-top: 1px;
      }
    }
    .rt-thead.-filters {
      .rt-th {
        padding: 15px !important;
      }
    }
    .rt-tr-group {
      border-bottom: ${(props) => props.theme.light_grey};
    }
    .rt-td {
      padding: 10px 15px !important;
      border-right: none !important;
      align-self: center;
      &:last-child {
        overflow: visible;
      }
      .rt-expandable {
        span {
          text-transform: capitalize;
        }
      }
    }
    .rt-expander {
      &:after {
        border-top-color: ${(props) => props.theme.blue_g} !important;
      }
    }
    .rt-noData {
      color: ${(props) => props.theme.light_grey} !important;
      background: rgba(26, 33, 41, 0.8) !important;
    }
    .-pagination {
      .-next,
      .-previous {
        .-btn {
          background-color: ${(props) => props.theme.accent_green};
          color: #fff;
          &:hover,
          &:focus {
            background-color: ${(props) =>
              darken(0.1, props.theme.accent_green)};
          }
        }
      }
      select {
        color: #fff !important;
        background: transparent;
      }
      .-pageInfo {
        input {
          color: #000;
        }
      }
    }
    .rt-tfoot {
      box-shadow: 0px 0px 3px 0px rgba(34, 34, 34, 0.2) !important;
      span {
        font-size: 12px;
      }
      p {
        margin: 0;
      }
    }
    .rt-noData {
      background: ${(props) => lighten(0.15, props.theme.dark_blue)};
      color: #ddd;
    }
    .active {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      color: #35d687;
      * {
        color: #35d687;
      }
    }
    .inactive {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      color: ${(props) => props.theme.med_grey};
      * {
        color: ${(props) => props.theme.med_grey};
      }
    }
    .table-select {
      width: 100%;
      box-shadow: none;
      border: 0;
      color: #fff;
      background: transparent;
    }
    .review-summary {
      background: ${(props) => lighten(0.05, props.theme.dark_blue)};
    }
    .fa-star[data-prefix="far"] {
      color: ${(props) => props.theme.light_grey} !important;
    }
    .fa-flag[data-prefix="far"] {
      color: ${(props) => props.theme.light_grey} !important;
    }
    /* Manager Review */
    .table-select,
    .review-input {
      &.changed {
        background: ${(props) => lighten(0.15, props.theme.dark_blue)};
      }
    }
    .content-list,
    .review-input {
      &.changed {
        background: ${(props) => darken(0.1, props.theme.light_grey)};
      }
    }
  }
  .actions {
    .dropdown {
      button {
        &.dropdown-toggle {
          background: transparent !important;
        }
        border: 0 !important;
        box-shadow: none !important;
        svg {
          color: ${(props) => lighten(0.15, props.theme.dark_blue)};
          font-size: 18px;
          margin-top: 5px;
        }
        &:hover,
        &:focus {
          border: 0 !important;
        }
        .caret {
          display: none;
        }
      }
    }
    .dropdown-menu {
      background: ${(props) => props.theme.dark_blue} !important;
      li {
        padding: 8px 15px !important;
        border-radius: 2px;
        &:not(:last-child) {
          border-bottom: 1px solid ${(props) => props.theme.dark_navy};
        }
        &:hover {
          background: ${(props) => lighten(0.05, props.theme.dark_blue)};
          transition: 0.3s;
          * {
            outline: none !important;
          }
        }
      }
      a {
        display: flex;
        align-items: center;
        text-decoration: none !important;
        background: none;
        color: #fff;
        padding: 0 !important;
        &:hover {
          background: transparent;
          color: #fff;
        }
        svg {
          margin-right: 10px;
        }
      }
    }
    button {
      margin: 0 !important;
      background: transparent !important;
      border: 1px solid ${(props) => props.theme.blue_g};
      color: ${(props) => props.theme.blue_g};
      padding: 8px 15px !important;
      &:focus,
      &:active {
        border: 1px solid ${(props) => props.theme.blue_g} !important;
        color: ${(props) => props.theme.blue_g} !important;
      }
    }
  }

  /* DROPDOWN MENU */
  .dropdown-on-header {
    #priorities-dropdown {
      padding: 7px 15px !important;
      height: 31px;
      font-weight: 800;
      margin-bottom: 5px;
      font-size: 12px;
    }
    .dropdown-menu {
      background: ${(props) => props.theme.dark_blue} !important;
      li {
        padding: 8px 15px !important;
        border-radius: 2px;
        &:not(:last-child) {
          border-bottom: 1px solid ${(props) => props.theme.dark_navy};
        }
        &:hover {
          background: ${(props) => lighten(0.05, props.theme.dark_blue)};
          transition: 0.3s;
          * {
            outline: none !important;
          }
        }
      }
      li.active {
        background: ${(props) => lighten(0.05, props.theme.dark_blue)};
      }
      a {
        display: flex;
        align-items: center;
        text-decoration: none !important;
        background: none;
        color: #fff;
        padding: 0 !important;
        &:hover {
          background: transparent;
          color: #fff;
        }
        svg {
          margin-right: 10px;
        }
      }
    }
  }

  .ReactTable.-highlight {
    .rt-tbody {
      .rt-tr {
        &:not(.-padRow) {
          &:hover {
            background: ${(props) => lighten(0.02, props.theme.dark_blue)};
          }
        }
      }
    }
  }

  .ReactTable.-striped {
    .rt-tr.-odd {
      background: ${(props) => props.theme.light_grey};
    }
    .rt-tr.-padRow {
      background-color: #fff;
    }
    .rt-tr-group {
      min-height: 50px;
      .rt-tr.-odd {
        background: $theme_xlight_grey;
      }
    }
    .rt-tbody {
      .rt-tr-group {
        border: 0px;
      }
    }
  }

  .ReactTable .-loading {
    background: ${(props) => props.theme.dark_navy} !important;
    div {
      top: 45% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
    }
  }

  .ReactTable {
    &.clients {
      .rt-td:first-child {
        text-align: center !important;
        span {
          display: block;
          margin: 0 auto;
          padding: 4px;
          width: 80px;
          text-transform: capitalize;
          border-radius: 20px;
          &.active {
            background: ${(props) => props.theme.green_g};
          }
          &.inactive {
            background: ${(props) => props.theme.red_g};
          }
        }
      }
      .rt-th:first-child .rt-resizable-header-content {
        justify-content: center !important;
      }
    }
  }

  /* USER PROFILE PAGE */
  .profile.avatar {
    &:hover {
      span {
        color: #fff;
        visibility: visible;
      }
    }
  }

  /* TIMESHEET */
  .time-sheet {
    &.header {
      .glyphicon-calendar {
        color: ${(props) => props.theme.dark_navy};
      }
      color: #000;
    }
    .time-header {
      .label {
        color: ${(props) => props.theme.light_grey};
        background: transparent;
      }
    }
    .time-row,
    .time-row-ticket {
      .css-vj8t7z,
      input {
        background: ${(props) => props.theme.dark_blue};
        border: none;
      }
      input {
        color: #fff !important;
      }
      .css-1hwfws3 input {
        color: ${(props) => props.theme.dark_grey} !important;
      }
      .css-2o5izw {
        .css-1hwfws3 {
          .css-xp4uvy {
            color: #000 !important;
          }
        }
      }
      .css-1hwfws3 {
        .css-xp4uvy {
          color: #fff !important;
        }
      }
    }
    .time-footer {
      .label {
        color: #fff;
      }
    }
  }

  .time-row {
    border-bottom: 1px solid ${(props) => props.theme.med_grey};
  }

  .time-row-ticket {
    background: #313e4f;
    border-radius: 5px;
    border-bottom: 1px solid #313e4f;
  }

  .red-text {
    color: red;
    font-size: 12px;
    margin-left: 1rem;
  }

  /* CALL TABLE */
  .call-stage {
    color: #fff;
  }

  .ticket-display {
    // background: ${(props) => props.theme.dark_navy};
    border: 0;
    color: #fff;
  }

  .CircularProgressbar {
    margin: 0 auto !important;
    .CircularProgressbar-trail {
      stroke: #fff;
    }
    .CircularProgressbar-path {
      stroke-linecap: square !important;
    }
    .CircularProgressbar-text {
      dominant-baseline: central !important;
      fill: #fff !important;
    }
    &.progressbar-success {
      .CircularProgressbar-path {
        stroke: ${(props) => props.theme.green_g};
      }
    }
    &.progressbar-warning {
      .CircularProgressbar-path {
        stroke: ${(props) => props.theme.gold_g};
      }
    }
    &.progressbar-danger {
      .CircularProgressbar-path {
        stroke: ${(props) => props.theme.red_g};
      }
    }
  }

  /* INVOICE */
  .invoice-preview {
    padding: 0 10px;
    table {
      width: 100%;
      font-size: 13px;
      table-layout: fixed;
      .header {
        font-size: 13px;
        padding: 5px !important;
        margin-bottom: 20px;
        td {
          border-bottom: 0px;
          text-align: left !important;
          padding: 0px;
          white-space: nowrap;
          p {
            /* min-width: 180px; */
          }
          &:not(:first-child) {
            text-align: right !important;
          }
        }
      }
      th {
        border: none;
      }
      tr {
        height: 40px;
      }
      th,
      td {
        min-width: 100px;
        padding: 10px 5px;
        border: none;
        border-bottom: 1px solid ${(props) => props.theme.light_grey};
        text-align: right;
      }
      .total {
        font-weight: 700;
        td {
          border-top: 1px solid ${(props) => props.theme.med_grey} !important;
          border-bottom: none !important;
        }
      }
      .procedure-name {
        height: auto;
        td {
          padding: 10px 5px 0px 5px;
          border: 0 !important;
        }
        p {
          margin: 0;
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }
  }

  .progress {
    height: 30px !important;
  }

  #customerDetailsModal,
  #contractDetailsModal,
  #contractDeleteModal {
    span > div:first-child {
      /* min-width: 500px; */
      .modal-body {
        max-height: 80vh !important;
        overflow: scroll !important;
      }
    }
  }

  /* CALENDAR */
  .rbc-calendar {
    /* height: 80vh !important; margin: 50px; */
    font-family: "Roboto";
    * {
      border-color: lighten(
        ${(props) => props.theme.dark_blue},
        20%
      ) !important;
    }
    .rbc-header {
      padding: 10px;
    }
    .rbc-today {
      background-color: ${(props) => lighten(0.05, props.theme.dark_navy)};
      border-left: 1px solid ${(props) => props.theme.dark_blue} !important;
    }
    .rbc-off-range-bg {
      background-color: ${(props) => props.theme.dark_navy} !important;
    }
    .toolbar-container {
      .views {
        margin: 10px 0;
        button {
          font-family: "Nunito";
          border-radius: 0 !important;
          margin: 0 !important;
          padding: 15px;
          outline: none;
          color: #fff;
          background: ${(props) => lighten(0.05, props.theme.dark_navy)};
          border: 0 !important;
          &.active {
            background: ${(props) => props.theme.blue_g} !important;
            color: #fff;
          }
          &:focus,
          &:active {
            color: #fff;
            background: ${(props) => props.theme.blue_g} !important;
          }
          &:first-child {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
          }
          &:last-child {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      }
      .calendar-view {
        border: 0 !important;
        box-shadow: 0 !important;
      }
      display: block;
      font-size: 25px;
      text-transform: uppercase;
      text-align: center;
      div {
        &:before {
          display: none;
        }
        svg {
          /* display: none; */
        }
        &[role="button"] {
          padding: 10px 5px 0 5px;
          font-size: 30px;
        }
      }
      .legend-item {
        margin-right: 5px;
        font-size: 12px;
        .legend-color {
          display: inline-block;
          height: 10px;
          width: 10px;
          margin: 0 8px;
        }
        .legend-text {
          display: inline-block;
          font-size: 13px !important;
          margin: 0 5px 0 0;
          text-transform: capitalize;
          font-family: "Nunito";
        }
      }
    }
    button {
      padding: 5px !important;
      font-size: 12px;
      border-radius: 3px;
      margin: 10px 5px;
      width: 33%;
      border: 0;
      svg {
        color: #000;
      }
      &:focus {
        outline: none;
      }
    }
  }

  .rbc-agenda-table {
    border: 0 !important;
    tr {
      border-top: none;
      &.date-cell-label {
        background: ${(props) => lighten(0.15, props.theme.dark_blue)};
        border: 0;
        padding: 5px 10px;
        font-weight: bold;
        font-size: 15px;
      }
      &.event-cell-row {
        display: flex;
        background: ${(props) => lighten(0.05, props.theme.dark_navy)};
        border: 0;
      }
    }
    th,
    td {
      padding: 10px;
      &.rbc-agenda-time-cell {
        max-width: 100px;
        display: flex;
        align-items: center;
        text-align: center;
        span {
          white-space: normal !important;
        }
      }
      &.rbc-agenda-event-cell {
        border-left: 0;
        a {
          display: block;
          p {
            font-family: "Nunito" !important;
          }
          h4 {
            font-weight: 700;
            color: #fff;
          }
          &:hover,
          &:focus {
            text-decoration: none !important;
          }
        }
      }
    }
  }

  .rbc-time-view {
    * {
      border-color: ${(props) =>
        lighten(0.1, props.theme.dark_navy)} !important;
    }
  }

  .DayPicker {
    margin: 0 auto;
  }

  /* WYSIWYG Styling */
  .rdw-link-modal {
    height: 235px;
  }

  .rdw-link-decorator-icon {
    display: none;
  }

  @media (min-width: 768px) {
    .container-fluid {
      margin-left: 225px;
    }
    // ::-webkit-scrollbar {
    //   width: 0px !important;
    //   background: transparent !important;
    // }
    #page-wrapper {
      position: inherit;
      padding: 0 30px;
      border-left: 1px solid #e7e7e7;
    }
    .sidebar {
      z-index: 2;
      position: absolute;
      /* width: 225px; margin-top: 50px; */
      margin-top: 130px;
      height: calc(100vh - 70px);
      overflow: auto;
    }
  }

  /* MOBILE */
  @media screen and (max-width: 767px) {
    .header-wrapper {
      .btn-warning,
      .btn-success,
      .btn-purple,
      .btn-info {
        &:not(#priorities-dropdown) {
          color: ${(props) => props.theme.blue_g};
          background: transparent !important;

          &:hover,
          &:focus {
            background: transparent !important;
          }
        }
      }
    }
    .content-wrapper {
      background: transparent !important;
      h1 {
        text-align: center;
      }
    }
    .panel {
      &.note-panel {
        .panel-heading {
          p {
            text-align: left;
          }
        }
        .panel-body {
          p {
            margin-bottom: 0;
          }
        }
      }
    }
    .navbar {
      .container {
        .sidebar {
          a {
            color: #fff !important;
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .auth-page {
      .col-sm-3 {
        width: 30%;
        padding: 0;
      }
      .col-sm-9 {
        width: 70%;
      }
    }
  }

  .-pageJump,
  .-pageSizeOptions {
    input[type="number"],
    select {
      background: ${(props) => props.theme.dark_input} !important;
      color: ${(props) => props.theme.grey_g} !important;
    }
  }

  .react-select-container {
    .react-select-container__control {
      background: ${(props) => props.theme.dark_input} !important;
      border: none;
      .react-select-container__placeholder,
      .react-select-container__single-value {
        color: ${(props) => props.theme.grey_g} !important;
      }
      .react-select-container__value-container {
        div {
          background: ${(props) => props.theme.dark_input} !important;
          color: ${(props) => props.theme.grey_g} !important;
          &.react-select-container__multi-value {
            background: ${(props) => props.theme.dark_blue} !important;
          }
        }
      }
    }
    .react-select-container__menu {
      background: ${(props) => props.theme.dark_blue};
      color: white;
      div {
        background: ${(props) => props.theme.dark_blue};
      }
    }
    .react-select-container__option {
      &:hover {
        background: #343b44 !important;
      }
    }
  }

  .avatar {
    background: #2e3a48;
  }

  /* CALL APPROVAL */
  .cap-container {
    .content-wrapper.cap-wrapper {
      background: ${(props) => props.theme.dark_navy};

      .row-wrapper {
        background: ${(props) => props.theme.dark_navy};
      }
    }

    .content-list {
      .list-item {
        background: ${(props) => props.theme.dark_blue};

        .list-item-wrapper {
          background: ${(props) => props.theme.dark_navy};
        }

        .notes {
          .row {
            background: ${(props) => props.theme.dark_blue};

            .col-xs-4 {
              background: ${(props) => props.theme.dark_blue};
            }
          }
        }
      }
    }

    // .tasks-service-container {
    //   .row {
    //     .review-input {
    //       background: #F4F6F9;
    //     }

    //     .table-select {
    //       background: #F4F6F9;
    //     }
    //   }
    // }
  }

  /* Surface */
  .surface-primary {
    background: ${(props) => props.theme.dark_navy};
  }

  .surface-secondary {
    background: ${(props) => props.theme.dark_blue};
  }

  .hide-button {
    background: #fff;
    color: ${(props) => props.theme.xdark_grey};
  }

  /* Dashboard */
  .dashboard {
    .header-actions-fixed {
      &.scrolled {
        background-color: ${(props) => props.theme.dark_navy};
      }
    }
  }

  /* IT Managed Report */
  .plan-details-container {
    .pd-top {
      .pd-top-right {
        .tier-box {
          box-shadow: none;
          background-color: ${(props) => props.theme.blue_g};
          color: #fff;
        }
      }
    }
    .sla-type {
      color: ${(props) => props.theme.blue_g};
    }
  }
  .metric-box {
    box-shadow: none;
  }
  .ticket-details-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-top: 2rem;
    text-align: center;

    .ticket-grid-col {
      display: grid;
      justifyitems: center;
      aligncontent: center;
      grid-template-columns: repeat(4, 1fr);
    }

    .leyend {
      font-size: 1.5rem;
      text-transform: uppercase;
    }
    .amount {
      color: ${(props) => props.theme.blue_g};
      font-size: 3.25rem;
    }
  }

  .resolve-time {
    background-color: ${(props) => props.theme.green_g};
    color: #fff;
  }
  .assign-time {
    background-color: ${(props) => props.theme.blue_g};
    color: #fff;
  }
  .maintenance-alerts {
    background-color: ${(props) => props.theme.gold_g};
    color: #fff;
  }
  .total-tickets {
    background-color: ${(props) => props.theme.red_g};
    color: #fff;
  }
  .input-group-addon {
    background-color: ${(props) => props.theme.dark_input} !important;
    border: solid 1px ${(props) => props.theme.dark_input};
    span {
      color: ${(props) => props.theme.grey_g} !important;
    }
  }

  /* Employee Summary By Project Report */
  .project-employee-summary-container {
    .toggle-wrapper {
      span {
        &.not-selected {
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
  .DayPicker_transitionContainer__horizontal {
    background: #2e3844;
  }
  .CalendarMonth_1 {
    background: #2e3844;
  }
  .CalendarMonthGrid {
    background: #2e3844;
  }
  .CalendarMonth_caption {
    strong {
      color: white;
    }
  }
  .DayPickerNavigation_button {
    background: #2e3844;
    border: none;
    svg {
      fill: white;
    }
  }
  .DayPicker {
    div {
      background: #2e3844;
    }
  }
  .DayPicker_weekHeader_li {
    color: white;
  }

  .CalendarDay__default {
    &:not(.CalendarDay__selected_span, .CalendarDay__selected) {
      background: #2e3844;
      color: white;
    }
  }

  .DayPickerKeyboardShortcuts_panel {
    color: white;
  }
`;

export default DarkStyles;
